import React from 'react';
import NotfoundImage from './404_pg_not_found.png'

export const NotFoundPage = () => {
    return (
        <div style={{padding: "2rem"}}>
            <img alt={"Not Found"} style={{display: "block", marginLeft: "auto", marginRight: "auto"}} src={NotfoundImage} width={"50%"} />
        </div>
    )
}